import React, { Component } from 'react';
import { connect } from "react-redux";
import { Field, reduxForm } from 'redux-form';

import { highFiveAdded } from '../../../redux/actions';

import { ShortField } from '../../atoms/formElements/formElements';
import Button from '../../atoms/button/button';
import { Mention } from '../listItems/listItems';
import { Tooltip} from '../../atoms/tooltip/tooltip';

import { EditorState, ContentState, convertToRaw } from 'draft-js';
import Editor from 'draft-js-plugins-editor';
import createMentionPlugin, { defaultSuggestionsFilter } from 'draft-js-mention-plugin';
import editorStyles from './editorStyles.css';

import 'draft-js-mention-plugin/lib/plugin.css';

class HighFive extends Component {
  constructor(props) {
    super(props);

    this.mentionPlugin = createMentionPlugin();
  }
  state = {
    editorState: EditorState.createEmpty(),
    suggestions: '',
    submit:''
  };
  componentWillMount() {
    const {employees, user} = this.props;
    if(employees) {
      var array = employees.filter(employee => employee.uid !== user.uid)
      this.setState({suggestions: array})
    }
  }

  onChange = (editorState) => {
    this.setState({
      editorState,
    });
  };

  onSearchChange = ({ value }) => {
    const {employees, user} = this.props;
    // can't @yourself
    let suggestions = employees.filter(employee => employee.uid !== user.uid)

    this.setState({
      suggestions: defaultSuggestionsFilter(value, suggestions),
    });
  };

  focus = () => {
    this.editor.focus();
  };
  handleSubmit(event) {
    event.preventDefault();
    const { editorState } = this.state
    let entityMap = convertToRaw(editorState.getCurrentContent()).entityMap;
    let message = convertToRaw(editorState.getCurrentContent()).blocks[0].text;
    if(entityMap[0]) {
      this.props.highFiveAdded(entityMap, message);
      this.setState({
        editorState: EditorState.createEmpty(),
        suggestions: this.props.employees,
        submit: 'High five was sent!'
      })
    } else {
      this.setState({
        editorState: EditorState.createEmpty(),
        suggestions: this.props.employees,
        submit: 'We need a co-worker!'
      })
    }
  }

  render() {
    const { MentionSuggestions } = this.mentionPlugin;
    const plugins = [this.mentionPlugin];

    return (
      <form id='highFiveAdd' >
        <div className='fieldWrapper'>
          <div className='textarea long' type='text' >
            <Editor
              editorState={this.state.editorState}
              placeholder='@coworker to give a high five!'
              onChange={this.onChange}
              plugins={plugins}
              ref={(element) => { this.editor = element; }}
            />
            <MentionSuggestions
              onSearchChange={this.onSearchChange}
              suggestions={this.state.suggestions}
              onAddMention={this.onAddMention}
              entryComponent={Mention}
            />
          </div>
        </div>
        <Button label='Send' disabled='false' state='small' onClick={event => this.handleSubmit(event)} />
        <span className='state'>{this.state.submit} </span>
        <Tooltip className='tooltipBig' position='right' content='Have an awesome coworker that deserves a high-five? Start typing @ before his/her name and give a compliment!'>
          <span className='floatinMdi mdi mdi-help-circle' />
        </Tooltip>

      </form>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.general.user,
    employees: state.employees
  };
}

export default reduxForm({
  // validate,
  form: 'highFive',
})( connect(mapStateToProps, { highFiveAdded })(HighFive));
